import '../scss/styles.scss';

export default function InquireRentals() {
    return (
        <section className="inquire-rentals">
            <div id="inquire" className="inquire-rentals-wrapper">
                <div className="inquire-text">
                    <h3>Submit Your Inquiry</h3>
                    <h2>Audio & Video <span>Equipment Rentals</span></h2>
                    <p>
                        We have an expanding list of audio equipment. <span>Faraway Sound Productions</span> focuses on high quality PA systems, monitors, instruments, and backline equipment for bands.
                    </p>
                    <ul>
                        <li className="icons-container">
                            <a className="email-btn"
                                href="mailto: jwhite@farawaysoundproductions.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            ></a>
                            <a className="email"
                                href="mailto: jwhite@farawaysoundproductions.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >jwhite@farawaysoundproductions.com</a>
                        </li>
                        <li className="icons-container">
                            <a className="call-btn"
                                href="tel:4062417299"
                                target="_blank"
                                rel="noopener noreferrer"
                            ></a>
                            <a className="call"
                                href="tel:4062417299"
                                target="_blank"
                                rel="noopener noreferrer"
                            >+1-406-241-7299</a>
                        </li>
                    </ul>
                </div>
                <div className="inquire-form">
                    <form
                        action="https://farawaysoundproductions.us8.list-manage.com/subscribe/post?u=9e36275267d6653c68daaef66&amp;id=33b6d1ecc4&amp;f_id=00f872e0f0"
                        method="post"
                        id="mc-embedded-subscribe-form"
                        className="validate"
                        name="mc-embedded-subscribe-form"
                        target="_self">
                        <div className="inquire-form-half">
                            <div className="form-half">
                                <label htmlFor="mce-FNAME">Full Name</label>
                                <input
                                    id="mce-FNAME"
                                    className="full-name"
                                    type="text"
                                    name="FNAME"
                                    pattern="^(\w\w+)\s(\w+)$"
                                    required
                                />
                                <span className="error-msg" aria-describedby="error-for-full-name"></span>
                            </div>
                            <div className="form-half">
                                <label htmlFor="mce-EMAIL">Email</label>
                                <input
                                    id="mce-EMAIL"
                                    className="validate"
                                    type="email"
                                    name="EMAIL"
                                    title="The domain portion of the email address is invalid (the portion after the @)."
                                    pattern="^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$"
                                    required
                                />
                                <span className="error-msg" aria-describedby="error-for-email"></span>
                            </div>
                        </div>
                        <div className="inquire-form-full">
                            <label htmlFor="mce-MMERGE8">Type of equipment</label>
                            <textarea
                                id="mce-EQUIPTMENT"
                                name="EQUIPTMENT"
                                className="rental-inquiry"
                                cols="40"
                                rows="10"
                                minLength="3"
                                maxLength="150"
                                placeholder="Please provide a description of the type of equipment you are inquiring about."
                                spellCheck="false"
                                required
                            >
                            </textarea>
                            <span className="error-msg" aria-describedby="error-for-message"></span>
                            <div hidden={true}><input type="hidden" name="tags" value="4889191" /></div>
                            <div style={{position: 'absolute', left: -5000}} aria-hidden="true">
                                <input type="text" name="b_9e36275267d6653c68daaef66_33b6d1ecc4" tabIndex="-1" value="" readOnly/>
                            </div>
                        </div>
                        <button className="inquire-now-btn"
                                type="submit"
                                name="subscribe"
                                id="mc-embedded-subscribe"
                        >Submit</button>
                    </form>
                </div>
            </div>
        </section>
    )
}